// 引入Vant 4
import Vant from 'vant'
import 'vant/lib/index.css'

import './assets/styles/main.styl'
import './assets/styles/global.styl'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from '@/views/App/index.vue'
import H5App from '@/views/H5/app.vue'
import router from './router'
import MessageService from '@/components/AppMessage/message'
import LoginService from '@zaohaowu/website-common/components/AppLogin/login'
import PostChallenge from '@/components/AppPostChallenge/postChallenge'
import ToastService from '@/components/AppToast/toast'
import VueObserveVisibility from 'vue3-observe-visibility'
import '@/types/global'
import '@/assets/styles/iconfont.css'
import getParamsFromUrl from '@/utils/shareSource'
import calcVh, { resizeCalcVh } from './utils/calcVh'
import i18n from '@/i18n'
import trackDirective from '@/directives/trackDirective'
import trackInit from '@/track/trackInit'
import unregisterPWA from '@/utils/unregisterPWA'
// TODO: 这里全量引入样式有性能风险
import 'element-plus/dist/index.css'
import { useGlobalConfigStore } from '@/stores/globalConfig'
import { useConfigStore } from './stores/configStore'
import getDomains from '@/utils/getDomains'
import isMobile from '@/utils/isMobile'

const isH5 = isMobile()
const app = createApp(isH5 ? H5App : App)

app.use(i18n)
app.use(Vant) // 注册Vant
app.provide('$message', MessageService)
app.provide('$login', LoginService)
app.provide('$postChallenge', PostChallenge)
app.provide('$toast', ToastService)
app.use(VueObserveVisibility)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate) // 启用插件
app.use(pinia)
app.use(router)
// 自定义埋点指令
app.use(trackDirective)

app.mount('#app')
// 存储运营活动来源
const htSource = getParamsFromUrl('ht_source')
if (htSource) {
  sessionStorage.setItem('ht_source', htSource)
}
// 计算移动端可视区域的vh值
calcVh()
resizeCalcVh()

// 初始化埋点配置
trackInit()

// 取消PWA
unregisterPWA()

// 获取全局配置
if (getDomains().thirdLevelDomain !== 'edu') {
  const globalConfigStore = useGlobalConfigStore()
  globalConfigStore.fetchConfig()
}
